import React from 'react';
import { Link } from 'react-router-dom';
import { XLogo, YoutubeLogo, FacebookLogo } from '@phosphor-icons/react';
import logoPath from '../logo.webp';
// using raster logo.webp for site branding

export const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-950 text-white pt-24 pb-12 border-t border-brand-900">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-12 gap-12 mb-20">
        <div className="col-span-1 md:col-span-12 lg:col-span-5">
          <Link to="/" className="inline-flex items-center gap-3 mb-8 group">
            <img src={logoPath} alt="Nida logo" className="w-16 h-auto" />
          </Link>
          <p className="text-gray-400 max-w-md mb-6 font-serif text-lg leading-relaxed">
            Nida Studios: In-Depth Politics, Trending Conversations & Premium Entertainment. Illuminating the truth in a complex world.
          </p>
          <div className="text-sm text-gray-300 mb-6 font-serif">
            <div><span className="font-bold">Call:</span> 0558116041</div>
            <div><span className="font-bold">WhatsApp:</span> 0506692176</div>
            <div><span className="font-bold">Email:</span> <a href="mailto:nidatv5050@gmail.com" className="hover:underline text-white">nidatv5050@gmail.com</a></div>
            <div><span className="font-bold">Address:</span> Akweteyman, Achimota SDA Church</div>
          </div>
          <div className="flex gap-4">
            <a href="https://x.com/nidatv_1?s=21" aria-label="X / Twitter" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-brand-900 rounded-full flex items-center justify-center hover:bg-brand-400 transition-all duration-300">
              <XLogo size={20} weight="fill" />
            </a>
            {/* Removed unused Instagram and LinkedIn links per request */}
            <a href="https://youtube.com/@nidatv_11?si=Sdj6xELsksKeGEtK" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-brand-900 rounded-full flex items-center justify-center hover:bg-brand-400 transition-all duration-300">
              <YoutubeLogo size={20} weight="fill" />
            </a>
            <a href="https://www.tiktok.com/@nidatv1?_r=1&_t=ZN-93uyOtCqCuM" aria-label="TikTok" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-brand-900 rounded-full flex items-center justify-center hover:bg-brand-400 transition-all duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true" className="text-white">
                <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.9-.32-1.89-.39-2.82-.14-.49.13-.95.36-1.35.68-.78.53-1.4 1.4-1.41 2.33-.04.41-.03.82.02 1.22.14 1.02.73 1.93 1.55 2.54.73.54 1.62.77 2.52.75 1.13-.01 2.21-.48 2.93-1.35.53-.6.84-1.39.92-2.18.06-2.61.02-5.23.04-7.84-.03-5.27.02-10.55.01-15.82z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/share/1F5eK4rRGT/?mibextid=wwXIfr" aria-label="Facebook" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-brand-900 rounded-full flex items-center justify-center hover:bg-brand-400 transition-all duration-300">
              <FacebookLogo size={20} weight="fill" />
            </a>
          </div>
        </div>

        <div className="md:col-span-4 lg:col-span-2 lg:col-start-7">
          <h4 className="text-xs font-black uppercase tracking-widest text-brand-500 mb-8">Network</h4>
          <ul className="space-y-4 text-sm font-bold text-gray-300">
            <li><Link to="/news" className="hover:text-brand-400 transition-colors">Latest News</Link></li>
            <li><Link to="/audio" className="hover:text-brand-400 transition-colors">Podcasts</Link></li>
            <li><Link to="/video" className="hover:text-brand-400 transition-colors">Documentaries</Link></li>
            <li><Link to="/newsletters" className="hover:text-brand-400 transition-colors">Newsletters</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4 lg:col-span-2">
          <h4 className="text-xs font-black uppercase tracking-widest text-brand-500 mb-8">Company</h4>
          <ul className="space-y-4 text-sm font-bold text-gray-300">
            <li><Link to="/about" className="hover:text-brand-400 transition-colors">About Us</Link></li>
            <li><Link to="/company/about" className="hover:text-brand-400 transition-colors">Our Team</Link></li>
            <li><Link to="/company/editorial-standards" className="hover:text-brand-400 transition-colors">Standards</Link></li>
            <li><Link to="/company/careers" className="hover:text-brand-400 transition-colors">Careers</Link></li>
            <li><Link to="/company/press-kit" className="hover:text-brand-400 transition-colors">Press Kit</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4 lg:col-span-2">
          <h4 className="text-xs font-black uppercase tracking-widest text-brand-500 mb-8">Support</h4>
          <ul className="space-y-4 text-sm font-bold text-gray-300">
            <li><Link to="/company/contact" className="hover:text-brand-400 transition-colors">Contact Us</Link></li>
            <li><Link to="/company/corrections" className="hover:text-brand-400 transition-colors">Corrections</Link></li>
            <li><Link to="/accessibility" className="hover:text-brand-400 transition-colors">Accessibility</Link></li>
            <li><span className="text-gray-600 cursor-not-allowed">Privacy Policy</span></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 pt-8 border-t border-brand-900 text-[10px] uppercase tracking-widest font-bold text-gray-600 flex flex-col md:flex-row justify-between items-center gap-4">
        <span>&copy; {new Date().getFullYear()} Nida Studios Inc. All rights reserved.</span>
        <span className="flex gap-4">
          <a href="#" className="hover:text-gray-400">Terms</a>
          <a href="#" className="hover:text-gray-400">Privacy</a>
          <a href="#" className="hover:text-gray-400">Sitemap</a>
        </span>
      </div>
    </footer>
  );
};